var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 397.47 82.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd200;}.cls-2{fill:#4bba36;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.68,89.91a43.58,43.58,0,1,0-87.15,0h.07a5.2,5.2,0,0,0-.07.69v7.86a6.43,6.43,0,0,0,6.41,6.42H91.26a6.44,6.44,0,0,0,6.42-6.42V90.6a5.2,5.2,0,0,0-.08-.69Z",
    transform: "translate(-10.47 -22.3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 87.15,
    height: 18.42,
    rx: 4.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.38,83.86a5.19,5.19,0,0,1-10.22-1.44V42.31a5.2,5.2,0,0,1,5.4-5.33,5.14,5.14,0,0,1,5.33,5.33V54.48A13.88,13.88,0,0,1,158,50.59c9.94,0,17.57,8.14,17.57,18.65S167.76,88,157.75,88C153.43,88,149.69,86.52,147.38,83.86Zm17.43-14.62a8.27,8.27,0,0,0-8.5-8.57c-4.89,0-8.35,3.6-8.35,8.57s3.46,8.57,8.35,8.57A8.23,8.23,0,0,0,164.81,69.24Z",
    transform: "translate(-10.47 -22.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.14,82.42V42.31a5.37,5.37,0,0,1,10.73,0V82.42a5.37,5.37,0,1,1-10.73,0Z",
    transform: "translate(-10.47 -22.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.48,69.24c0-10.51,8.42-18.65,19.22-18.65s19.16,8.14,19.16,18.65S225.5,88,214.7,88,195.48,79.75,195.48,69.24Zm27.65,0a8.46,8.46,0,1,0-16.92,0,8.24,8.24,0,0,0,8.49,8.64C219.6,77.88,223.13,74.28,223.13,69.24Z",
    transform: "translate(-10.47 -22.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237,69.24c0-10.51,8.28-18.65,19.15-18.65,5.26,0,10.66,2.3,13.54,5.55a6.33,6.33,0,0,1,1.8,4.46,4.92,4.92,0,0,1-5.11,5,4.6,4.6,0,0,1-3.46-1.51c-1.58-1.66-3.45-3.39-6.77-3.39a8.21,8.21,0,0,0-8.42,8.57,8.27,8.27,0,0,0,8.42,8.64c3.32,0,5.19-1.8,6.77-3.38A4.44,4.44,0,0,1,266.4,73a4.92,4.92,0,0,1,5.11,5,6.09,6.09,0,0,1-1.8,4.4c-2.88,3.31-8.28,5.61-13.54,5.61C245.3,88,237,79.75,237,69.24Z",
    transform: "translate(-10.47 -22.3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.84,82.42V42.31a5.2,5.2,0,0,1,5.4-5.33,5.14,5.14,0,0,1,5.32,5.33v24l13-13.61a5.5,5.5,0,0,1,4-2,5,5,0,0,1,4.89,4.9,5,5,0,0,1-1.65,3.75l-7.56,7.77L309,79.47a5.44,5.44,0,0,1,1.15,3.31,5.13,5.13,0,0,1-5.18,5,6.28,6.28,0,0,1-5.11-3.1L292.6,74.35l-5,5.19v2.88a5.16,5.16,0,0,1-5.32,5.4A5.22,5.22,0,0,1,276.84,82.42Z",
    transform: "translate(-10.47 -22.3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.64,82.42V42.31a5.36,5.36,0,0,1,10.72,0V82.42a5.36,5.36,0,1,1-10.72,0Z",
    transform: "translate(-10.47 -22.3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M330,69.24c0-10.51,8.43-18.65,19.23-18.65s19.15,8.14,19.15,18.65S360,88,349.2,88,330,79.75,330,69.24Zm27.65,0a8.46,8.46,0,1,0-16.92,0,8.25,8.25,0,0,0,8.5,8.64C354.09,77.88,357.62,74.28,357.62,69.24Z",
    transform: "translate(-10.47 -22.3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373,82.42V56.14a5.24,5.24,0,0,1,5.19-5.48,4.93,4.93,0,0,1,4.89,4,13,13,0,0,1,9.87-4c8.86,0,15.05,6,15.05,16V82.42a5.16,5.16,0,0,1-5.33,5.4,5.22,5.22,0,0,1-5.4-5.4V68c0-4.54-2.59-7.28-6.55-7.28-4.25,0-7,2.81-7,7.28v14.4a5.16,5.16,0,0,1-5.33,5.4A5.22,5.22,0,0,1,373,82.42Z",
    transform: "translate(-10.47 -22.3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 331.62,
    cy: 20.3,
    r: 5.61
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 345.83,
    cy: 20.3,
    r: 5.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b5272193bcaa0566f32e0da44a9f686.svg";
export { ForwardRef as ReactComponent };